export default __webpack_public_path__ + "static/media/mycontracts.7363350c.svg";